import query from 'dom-helpers/query';
import config from '../pjax/config';
import utils from '../pjax/utils';

class Standard {
    constructor() {
        this.view = config.$view;
        this.page = null;
        this.a = null;
        this.ui = {};
    }

    init(req, done, options) {
        const opts = options || { cache: true, sub: false };
        const view = this.view;
        const ready = this.dataAdded.bind(this, done);

        this.page = utils.loadPage(req, view, opts, ready);
    }

    dataAdded() {
        this.a = query.querySelectorAll(this.page, 'a');
        utils.addRoutingEL(this.a);
    }

    destroy() {
        if (this.a) {
            utils.removeRoutingEL(this.a);
        }
        this.a = null;
    }
}

export default Standard;



/** WEBPACK FOOTER **
 ** ./sections/standard.js
 **/